import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { useCurrency } from "@shared/selectors/globalSelectors";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@shared/ui/accordion";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { FileText } from "lucide-react";

export const BillOverview = ({ bill }) => {
  const currency = useCurrency();

  const BILL_OVERVIEW_FIELDS = [
    {
      label: "Phone",
      getValue: (bill) => bill.consumerContactNo,
    },
    {
      label: "Email",
      getValue: (bill) => bill.consumerEmail,
    },
    {
      label: "Service Days",
      getValue: (bill) => `${bill.serviceDays} Days`,
    },
    {
      label: "Billed On",
      getValue: (bill) => bill.createdDate,
    },
    {
      label: "Plan",
      getValue: (bill) => bill.plan,
    },
    {
      label: "Services",
      getValue: (bill) => (
        <div className="flex gap-2">
          {bill?.services?.map((s) => (
            <Badge key={s} variant="outline">
              {s}
            </Badge>
          ))}
        </div>
      ),
    },
  ];
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem
        value={bill.billNumber}
        className="rounded-lg border shadow-md"
      >
        {/* COLLAPSED VIEW */}
        <AccordionTrigger className="px-4 py-3 hover:no-underline">
          <div className="flex w-full items-center justify-between gap-4">
            <div className="space-y-1 text-left">
              <div className="flex items-center gap-2">
                <span className="font-semibold">{bill.billNumber}</span>
                <Badge variant="success">{bill.billStateLabel}</Badge>
              </div>
              <p className="text-sm text-muted-foreground">
                {bill.firstName} {bill.lastName} • {bill.remoteConsumerNumber}
              </p>
              <p className="text-xs text-muted-foreground">
                Billing Period - {bill.billingPeriod}
              </p>
            </div>

            <div className="text-right font-semibold text-lg">
              {currency} {bill.billAmount?.toFixed(2)}
            </div>
          </div>
        </AccordionTrigger>

        {/* EXPANDED VIEW */}
        <AccordionContent className="px-4 pb-4">
          <div className="grid gap-6 md:grid-cols-2">
            {BILL_OVERVIEW_FIELDS.map((field) => (
              <ValueLabel
                key={field.label}
                label={field.label}
                value={field.getValue(bill)}
              />
            ))}
          </div>

          <div className="mt-6 flex justify-end">
            <Button variant="outline">
              <FileText className="mr-2 h-4 w-4" />
              View Bill
            </Button>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
